import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Globe, Clock } from "lucide-react";
import { Crest, FlagStrip } from "@/components/Brand";
import { NACASKY } from "@/lib/brand";

const PASSENGER_LINKS = [["Book a trip", "/"], ["Find my ticket", "/find"], ["Track my bus", "/track"], ["Live station board", "/arrivals"], ["How it works", "/how-it-works"]];
const COMPANY_LINKS = [["Terms & Conditions", "/terms"], ["Operations handbook", "/operations"], ["Staff portal login", "/admin"]];

export default function SiteFooter() {
  return (
    <footer className="no-print mt-auto bg-[#0E1A5C] text-blue-100" data-testid="site-footer">
      <FlagStrip />
      <div className="relative mx-auto grid max-w-7xl gap-10 overflow-hidden px-4 py-12 sm:px-6 lg:grid-cols-[1.4fr_0.8fr_0.8fr_1.2fr]">
        <Crest variant="white" className="pointer-events-none absolute -right-16 -top-10 h-72 w-72 opacity-[0.05]" />
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <span className="grid h-14 w-14 place-items-center rounded-full bg-white"><Crest className="h-12 w-12" testid="footer-gprtu-crest" /></span>
            <div className="leading-tight">
              <div className="font-display text-xl font-extrabold text-white">GPRTU Intercity</div>
              <div className="text-[11px] font-semibold uppercase tracking-[0.14em] text-blue-200">Ghana Private Road Transport Union of T.U.C.</div>
            </div>
          </div>
          <p className="max-w-sm text-sm text-blue-200/90">The official GPRTU platform for intercity bus tickets, counter sales, bus sign-out and revenue sharing at union stations across Ghana.</p>
          <div className="font-display text-sm font-bold tracking-[0.3em] text-[#FCD116]">UNITED WE STAND</div>
        </div>

        <div>
          <div className="label-xs mb-3 !text-blue-300">Passengers</div>
          <ul className="space-y-2 text-sm">
            {PASSENGER_LINKS.map(([l, to]) => <li key={to}><Link to={to} className="transition-colors hover:text-white" data-testid={`footer-link-${to.replace(/\//g, "") || "home"}`}>{l}</Link></li>)}
          </ul>
        </div>

        <div>
          <div className="label-xs mb-3 !text-blue-300">Company & legal</div>
          <ul className="space-y-2 text-sm">
            {COMPANY_LINKS.map(([l, to]) => <li key={to}><Link to={to} className="transition-colors hover:text-white" data-testid={`footer-link-${to.replace(/\//g, "")}`}>{l}</Link></li>)}
            <li><a href={NACASKY.webHref} target="_blank" rel="noreferrer" className="transition-colors hover:text-white" data-testid="footer-link-about-nacasky">About {NACASKY.name}</a></li>
          </ul>
        </div>

        <div className="rounded-2xl bg-white p-5 text-slate-700" data-testid="nacasky-footer-brand">
          <div className="label-xs">Developed &amp; operated by</div>
          <a href={NACASKY.webHref} target="_blank" rel="noreferrer" data-testid="nacasky-footer-link"><img src="/brand/nacasky-logo.svg" alt="Nacasky Company Limited" className="mt-2 h-10 w-auto" /></a>
          <ul className="mt-3 space-y-1.5 text-xs" data-testid="nacasky-contact">
            <li className="flex items-start gap-2"><MapPin className="mt-0.5 h-3.5 w-3.5 shrink-0 text-[#0284C7]" />{NACASKY.address}</li>
            <li className="flex items-center gap-2"><Phone className="h-3.5 w-3.5 text-[#0284C7]" /><a href={NACASKY.phoneHref} className="hover:underline">{NACASKY.phone}</a></li>
            <li className="flex items-center gap-2"><Mail className="h-3.5 w-3.5 text-[#0284C7]" /><a href={NACASKY.emailHref} className="hover:underline">{NACASKY.email}</a></li>
            <li className="flex items-center gap-2"><Clock className="h-3.5 w-3.5 text-[#0284C7]" />{NACASKY.hours}</li>
            <li className="flex items-center gap-2"><Globe className="h-3.5 w-3.5 text-[#0284C7]" /><a href={NACASKY.webHref} target="_blank" rel="noreferrer" className="font-semibold text-[#0052FF] hover:underline">{NACASKY.web}</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-4 text-xs text-blue-300 sm:flex-row sm:px-6">
          <span>© {new Date().getFullYear()} GPRTU of T.U.C. · All rights reserved</span>
          <span data-testid="footer-powered-by">{NACASKY.tagline}</span>
        </div>
      </div>
    </footer>
  );
}
